import React, { memo, useState, ReactNode } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { Tabs, Tab, Box, Container } from '@material-ui/core';
import { FormattedMessage } from "react-intl";
import GenericPageHeader from '../../../legacy-components/page-headers/GenericPageHeader';
import Loader from "../../../legacy-components/loader";

interface TabPanelProps {
  children?: ReactNode;
  value: number;
  index: number;
  dir?: string;
}

interface FullWidthTabsProps {
  teamProxies: ReactNode;
  sharedProxies: ReactNode;
  header: ReactNode;
}

const TabPanel: React.FC<TabPanelProps> = memo(({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`full-width-tabpanel-${index}`}
    {...other}
  >
    {value === index && (
      <Container>
        <Box>
          {children}
        </Box>
      </Container>
    )}
  </div>
));

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1
  },
}));

const ProxyTabs: React.FC<FullWidthTabsProps> = memo(({ teamProxies, sharedProxies, header }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: number): void => {
    setValue(newValue);
  };

  const handleChangeIndex = (index: number): void => {
    setValue(index);
  };

  return (
    <div className={classes.root}>
      <GenericPageHeader title={<FormattedMessage defaultMessage="API Proxies" />} controls={header as any} />
      <Tabs
        indicatorColor="primary"
        value={value}
        onChange={handleChange}
      >
        <Tab label={<FormattedMessage defaultMessage="Team" />} />
        <Tab label={<FormattedMessage defaultMessage="Shared" />} />
      </Tabs>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <br />
          <div className="proxy-list">
            <div className="team-api-list">
              {!teamProxies ? <div className="proxy-loader"><Loader /></div> : teamProxies}
            </div>
          </div>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <br />
          <div className="sharedproxy-list">
            <div className="shared-api-list">
              {sharedProxies}
            </div>
          </div>
        </TabPanel>
      </SwipeableViews>
    </div>
  );
});

export default ProxyTabs;
